exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form-container[data-v-064eaf52]{position:relative}.logo-container[data-v-064eaf52]{position:absolute;top:-60px;left:50%;transform:translateX(-50%);width:120px;height:120px;background:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 8px 30px rgba(0,0,0,.25);z-index:3;border:4px solid #fff}.logo-image[data-v-064eaf52]{width:80px;height:80px;-o-object-fit:contain;object-fit:contain}.form-input[data-v-064eaf52]{border-width:1px}.form-input[data-v-064eaf52]:focus{outline:none;box-shadow:0 0 0 3px rgba(59,130,246,.1)}", ""]);

// exports
